import React, { useState, useEffect } from 'react';
import {Dblogs} from './Dblogs'
import axios from "axios";

export const DblogHandler = (props)=>{
    const [myData, setMyData] = useState([])
    var option = {
      method: 'GET',
      url: 'https://karlson.herokuapp.com'
    };
    useEffect(()=>{
      axios
      .request(option)
      .then(function(response) {
        let data = JSON.stringify(response.data.data)
        setMyData(JSON.parse(data))
        console.log("Succesfully fetched elements and all posts")
      })
      .catch(function(err) {
        console.log(err);
      });      
    }, [])
    return (
  	<div className = "container text-start">
    {myData.map((post)=>{
        return <Dblogs key = {post.slug} mypost = {post}/>
    })}
    </div>
)}